import React, { useEffect, useMemo, useState } from 'react';
import './SPReport.less';

import { useParams } from 'react-router-dom';
import ReportRegisterTab from '../components/SPReportTabs/ReportRegisterTab';
import BackBtn from '../components/UI/BackBtn';
import IndexesTab from '../components/SPReportTabs/IndexesTab';
import { Tabs, Tab } from '../components/Tabs';
import icn from '../../img/icons/icon14_sm.svg';
import useUserContext from '../hooks/useUserContext';
import useNavProject from '../hooks/useNavProject';
import useAPI from '../hooks/useAPI';
import WidgetsGrid from '../components/_layout/WidgetsGrid';
import { hasPermsOnIndexesOrReceipts } from '../services/rolesSvc';

export default function SPReport() {
  const { stratId } = useParams();
  const userCtx = useUserContext()

  const [project, setProject] = useState(null);

  const navProject = useNavProject();
  const api = useAPI();

  const routes = useMemo(() => [
    {name: 'Реестр отчётов', url: `/strats/${stratId}/report/reports`},
    {name: `Унифицированные показатели проектов СП`, url: `/strats/${stratId}/report/unified`, show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId})},
    {name: `Вехи проектов, входящих в СП`, url: `/strats/${stratId}/report/milestones`},
    {name: `Поступления от научной и иновационной деятельности`, url: `/strats/${stratId}/report/receipts`}
  ], [stratId, project, userCtx])

  useEffect(async () => {
    const result = await api.get(`/mng/strategies/${stratId}`);
    navProject.setStratTitle(result.name);
    setProject(result);
  }, []);

  return (
    <section className="page project-page">
      <div style={{ padding: '3em' }}>
        <div style={{ marginBottom: 16 }}>
          <BackBtn />
        </div>
        {project && (
        <div className="project-title-wrapper">
          {project.logo && (
          <div className="project-logo-wrapper">
            <img className="project-logo" src={`data:image/svg+xml;base64,${project.logo}`} alt="project-icon" />
            <div className="num">{project.num}</div>
          </div>
          )}
          <h3>Отчёт по СП №{project.id} "{project.name}"</h3>
        </div>
        )}
        <WidgetsGrid items={routes.filter((w) => !w.show || w.show(userCtx.perms))} />
      </div>
    </section>
  );
}
const styledHeading = { marginLeft: 0, marginBottom: 24 };
